/** IVA toggle: off = sin IVA, on = con IVA */
export const ivaPriceSwitchSx = {
  width: 44,
  height: 26,
  padding: 0,
  flexShrink: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '2px',
    transitionDuration: '200ms',
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#5FC56E',
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
    boxShadow: '0 1px 3px rgba(0,0,0,.25)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 13,
    backgroundColor: '#94a3b8',
    opacity: 1,
  },
}
